import { AES, enc } from 'crypto-js';

const salt = 'lkjh12';
export const encrypt = (value: string): string =>
  AES.encrypt(value, salt).toString();

export const decrypt = (value: string): string =>
  AES.decrypt(value, salt).toString(enc.Utf8);

export const encryptWithEncode = (
  object: object | string | number,
  encryptKey: string
) => {
  const encJson = AES.encrypt(JSON.stringify(object), encryptKey).toString();
  const encData = enc.Base64.stringify(enc.Utf8.parse(encJson));
  return encData;
};

export function decryptWithParse<T = any>(
  word: string,
  key: string
): T | undefined {
  try {
    const decData = enc.Base64.parse(word).toString(enc.Utf8);
    const bytes = AES.decrypt(decData, key).toString(enc.Utf8);
    return JSON.parse(bytes);
  } catch {
    return;
  }
}

export const encryptUrl = (value: string) => encryptWithEncode(value, salt);
export const decryptUrl = (value: string) => decryptWithParse(value, salt);
